import { Box } from '@mui/material'
import { FC } from 'react'
import { Trans } from 'react-i18next'
import { Link } from '../Link'

const Footer: FC = () => {
  return (
    <Box component="footer" mt={6} typography="body2" textAlign="center">
      <Trans i18nKey="Powered by<br/><2><0></0></2>">
        Powered by
        <br />
        <Link href="https://xoda.com/" target="_blank">
          <img src="/images/logo.svg" alt="Xoda" />
        </Link>
      </Trans>
    </Box>
  )
}

export { Footer }
